// FASE 1 Clubbers rediseño — tokens de diseño
export const COLORS = {
  bg: '#0A0A0C',
  surface: '#141417',
  surfaceAlt: '#1E1E22',
  surfaceSheet: '#131316',
  surfaceNav: '#0F0F12',
  border: '#232328',
  borderStrong: '#2A2A30',
  primary: '#DC3545',
  primaryDark: '#5C1620',
  coral: '#F26B77',
  text: '#FFFFFF',
  textMuted: '#8E8E98',
  textDim: '#52525b',
};

// Colores fijos por sala (fallback cuando no hay imagen real).
// venue_id -> {bg, icon}
export const VENUE_PALETTE = [
  { bg: '#3E1F2B', icon: '#F4A6BC' }, // vino
  { bg: '#1F2A44', icon: '#8FAEF0' }, // azul marino
  { bg: '#4A3014', icon: '#F2B26B' }, // marrón
  { bg: '#2A1F45', icon: '#B9A2F0' }, // morado
  { bg: '#1F3F3F', icon: '#7FD6C9' }, // verde azulado
];

export function paletteFor(venueId) {
  const i = Math.abs(Number(venueId) || 0) % VENUE_PALETTE.length;
  return VENUE_PALETTE[i];
}

export const WEEKDAY_SHORT = ['LUN', 'MAR', 'MIÉ', 'JUE', 'VIE', 'SÁB', 'DOM']; // ISO (lunes=0)
export const WEEKDAY_FULL = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];
export const MONTHS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
export const MONTHS_SHORT = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

// Returns {hoy, mañana, finde (Vie-Dom), isSame}
export function dateKey(d) {
  if (!d) return '';
  const z = new Date(d);
  return `${z.getFullYear()}-${String(z.getMonth() + 1).padStart(2, '0')}-${String(z.getDate()).padStart(2, '0')}`;
}

export function fmtDayPretty(d) {
  // "Sábado 10 de octubre"
  const z = new Date(d);
  const dow = (z.getDay() + 6) % 7; // lunes=0
  return `${WEEKDAY_FULL[dow]} ${z.getDate()} de ${MONTHS[z.getMonth()]}`;
}

export function fmtDayShort(d) {
  // "Sáb, 10 de Oct"
  const z = new Date(d);
  const dow = (z.getDay() + 6) % 7;
  const w = WEEKDAY_SHORT[dow].charAt(0) + WEEKDAY_SHORT[dow].slice(1).toLowerCase();
  return `${w}, ${z.getDate()} de ${MONTHS_SHORT[z.getMonth()].charAt(0).toUpperCase()}${MONTHS_SHORT[z.getMonth()].slice(1)}`;
}

export function fmtTime(d) {
  const z = new Date(d);
  return `${String(z.getHours()).padStart(2, '0')}:${String(z.getMinutes()).padStart(2, '0')}`;
}
